module.exports = __webpack_public_path__ + "static/finn-forest-55b78bbb14c29e9766aaddc2b3a060fe.jpg";